export default {
	namespaced: true,

	state: () => ({
		message: {
			text: "",
			color: "info",
		},
		snackbar: false,
		timeout: 6000,
	}),

	mutations: {
		setMessage(state, payload) {
			state.message = payload;
		},
		setSnackbar(state, payload) {
			state.snackbar = payload;
		},
		setTimeout(state, payload) {
			state.timeout = payload;
		},
	},

	getters: {
		getMessage: (state) => state.message,
		getSnackbar: (state) => state.snackbar,
		getTimeout: (state) => state.timeout,
	},
};
